import React, { createContext, useEffect } from "react"
import useWhatsApps from "../../hooks/useWhatsApps"
import { useHistory } from "react-router-dom"

const WhatsAppsContext = createContext()

const WhatsAppsProvider = ({ children }) => {
  const history = useHistory()
  const {
    loading,
    whatsApps,
    refetchWhatsApps,
    comandoFalhouAlert,
    limparComandoFalhouAlert,
    aplicarDesconexaoOtimista,
  } = useWhatsApps()
  const token = localStorage.getItem("token")
  useEffect(() => {
    if (!token) {
      console.log("Token não encontrado, redirecionando para o login")
      history.push("/login")
    }
  }, [history])

  if (!token) {
    return null
  }

  return (
    <WhatsAppsContext.Provider
      value={{
        whatsApps,
        loading,
        refetchWhatsApps,
        comandoFalhouAlert,
        limparComandoFalhouAlert,
        aplicarDesconexaoOtimista,
      }}
    >
      {children}
    </WhatsAppsContext.Provider>
  )
}

export { WhatsAppsContext, WhatsAppsProvider }
